"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { SuggestionItem, SuggestionType } from "@/types/suggestions";
import { useSuggestions } from "@/api/query/provider/suggestions";
interface UseSuggestionsListOptions {
  primaryPatientId: string | undefined;
  eventId: string | undefined;
}
interface UseSuggestionsListReturn {
  suggestions: SuggestionItem[];
}
export function useSuggestionsList(t0) {
  const $ = _c(6);
  const {
    primaryPatientId,
    eventId
  } = t0;
  let types;
  if ($[0] !== eventId) {
    types = ["PERSONAL", "PATIENT", "SAVED", "TENANT"];
    if (eventId) {
      types.push("EVENT");
    }
    $[0] = eventId;
    $[1] = types;
  } else {
    types = $[1];
  }
  const suggestionTypes = types;
  const {
    data: t1
  } = useSuggestions(suggestionTypes, primaryPatientId, eventId);
  let t2;
  if ($[2] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const suggestions = t2;
  let t3;
  if ($[4] !== suggestions) {
    t3 = {
      suggestions
    };
    $[4] = suggestions;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}